var d3 = {
    ...require("d3-selection/dist/d3-selection.min"),
  };

function classify(str) {
    return (str + "").toLowerCase()
      .replace(/\s+/g, '-')           // Replace spaces with -
      .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
      .replace(/\-\-+/g, '-')         // Replace multiple - with single -
      .replace(/^-+/, '')             // Trim - from start of text
      .replace(/-+$/, '');            // Trim - from end of text
  };
  
var links = d3.selectAll("a");

links.each(function(){
  classes = this.classList.value;
  if(!(classes.includes('internal_link'))){
    this.setAttribute('target', '_blank');
  }else{
    link_target = this.href;
    link_target = link_target.slice(link_target.indexOf("#"));
    if(link_target.includes("%20")){
      link_target = link_target.replace(/%20/g, '-').toLowerCase();
      this.href = link_target;
    }
    this.href = "#" + classify(link_target);
  }
});

